import { render, staticRenderFns } from "./EventLocationField.vue?vue&type=template&id=09ccb788"
import script from "./EventLocationField.vue?vue&type=script&lang=js"
export * from "./EventLocationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports